import React, { PureComponent } from 'react';

class WalkmeContainer extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      curStep: 0,
    };
  }

  onNext = () => {
    this.setState((prevState) => ({
      curStep: prevState.curStep + 1,
    }));
  };

  onComplete = (event) => {
    this.onNext(event);
    this.props.onComplete(event);
  };

  render() {
    const totalStep = React.Children.count(this.props.children);

    if (this.state.curStep >= totalStep) return null;

    return React.Children.map(this.props.children, (child, index) => {
      if (this.state.curStep == index) {
        const isLastStep = index == totalStep - 1;
        return React.cloneElement(child, {
          nextLabel: this.props.nextLabel
            ? this.props.nextLabel
            : (isLastStep
            ? '立即使用'
            : `下一步(${index + 1}/${totalStep})`),
          onNext: isLastStep ? this.onComplete : this.onNext,
          show: true,
          hideSkip: isLastStep,
          onSkip: this.props.onSkip,
        });
      }
    });
  }
}

export default WalkmeContainer;
